import React from 'react';

const TestEnv = () => {
  console.log('Test - REACT_APP_STRIPE_PUBLISHABLE_KEY:', process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  console.log('All environment variables:', process.env);

  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0', margin: '20px', borderRadius: '5px' }}>
      <h3>Test des variables d'environnement</h3>
      <p><strong>REACT_APP_STRIPE_PUBLISHABLE_KEY:</strong> {process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ? 'Définie' : 'Non définie'}</p>
      <p><strong>NODE_ENV:</strong> {process.env.NODE_ENV}</p>
      <p><strong>REACT_APP_API_URL:</strong> {process.env.REACT_APP_API_URL}</p>
    </div>
  );
};

export default TestEnv;
